<lx-selector-field-container
  [label]="labelVisible ? classTimeLabel : ''"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="classTimeSelector_field"
>
  <ng-container *ngIf="selectedValue?.label === firstOptionLabel; else notDefault">
    {{ selectedValue?.label }}
  </ng-container>
  <ng-template #notDefault>
    {{ selectedValue?.startTime | lxOffsetTime : selectedTimezoneOffset }} - {{ selectedValue?.endTime | lxOffsetTime : selectedTimezoneOffset }}
  </ng-template>
</lx-selector-field-container>

<lx-side-panel i18n-title title="Select a class time" size="large" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" data-qa="classTimeSelector_sidePanel">
  <div class="listbox-options">
    <lx-list-box
      [options]="onlineCourses$ | async"
      [(ngModel)]="selectedValue"
      (ngModelChange)="triggerSelectedClassTimeChanged()"
      data-qa="classTimeSelector__list"
      optionLabel="label"
    >
    </lx-list-box>
  </div>
</lx-side-panel>
